import { defaultColors, defaultDougnutDatasetOptions, defaultDougnutOptions, onlyUnknowns } from '@/utils/analytics'
import { translationMap } from '@/utils/analytics'

/**
 * @param {vueInstance} context - This.
 * @param {string} label - The card label.
 * @param {string} groupKey - The group key used to extract data from API.
 * @returns {DoughnutChart} The chart configuration object.
 */
export default function (context, label, groupKey) {
  return {
    key: `demography_${label}_buyers`,
    resource: {
      endpoint: 'demography_buyers',
      filter: {
        'filter.statuses': ['sold'],
      },
    },
    type: 'Doughnut',
    title: {
      id: label,
      label: context.$t(translationMap[label] || label),
      style: true,
    },
    data: props => {
      const { data = {} } = props
      const groupData = data.values && data.values[groupKey] ? data.values[groupKey].data : {}
      if (onlyUnknowns(groupData)) return {}

      return {
        labels: Object.keys(groupData).map(key => context.$t(translationMap[key] || key)),
        datasets: [
          {
            ...defaultDougnutDatasetOptions,
            backgroundColor: Object.values(defaultColors),
            data: Object.values(groupData).map(v => v.length),
          },
        ],
      }
    },
    options: defaultDougnutOptions,
    total: ({ data = {} }) => {
      const groupDataTotal = data.values && data.values[groupKey] ? data.values[groupKey].occurrences : {}
      const { key = '', percent = 0 } = groupDataTotal
      return {
        heading: `${context.$t(key)}`,
        subheading: `${Math.round(percent * 100)} %`,
      }
    },
    colors: Object.values(defaultColors),
    dimensions: ({ data = {}, colors }) => {
      const groupData = data.values && data.values[groupKey] ? data.values[groupKey].data : {}

      return Object.keys(groupData).map((key, index) => ({
        id: key,
        label: context.$t(translationMap[key] || key),
        value: context.valueParser(groupData[key].length),
        icon: '',
        marker: colors[index],
      }))
    },
    heading: { id: label, label: context.$t(translationMap[label] || label), style: '' },
  }
}
